// hooks/useMobile.js
import { useState, useEffect } from 'react';

export default function useMobile() {
  // ✅ FIXED: Guard window access — throws in SSR/test environments without this
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= 768 : false
  );

  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);

  return isMobile;
}